import { gql } from '@apollo/client';

export const updateServicePlans = gql`
  mutation updateServicePlans(
    $id: Int
    $userType: String!
    $planName: String!
    $price: Float!
    $currency: String
    $duration: String
    $description: String
    $serviceFee: Float
    $aiFeaturesStatus: Boolean
    $mediaImage: String
    $dynamicServicePlans:String
  ) {
    updateServicePlans(
      id: $id
      userType: $userType
      planName: $planName
      price: $price
      currency: $currency
      duration: $duration
      description: $description
      serviceFee: $serviceFee
      aiFeaturesStatus: $aiFeaturesStatus
      mediaImage: $mediaImage
      dynamicServicePlans: $dynamicServicePlans
    ) {
      status
      errorMessage
    }
  }
`;


export const getAllServicePlans = gql`query getAllServicePlans($currentPage: Int, $searchKey: String, $userType:String) {
    getAllServicePlans(currentPage: $currentPage, searchKey: $searchKey, userType:$userType) {
        status
        errorMessage
        count
        results {
          id
          userType
          planName
          duration
          currency
          description
          price
		      serviceFee
          serviceType
          mediaImage
          aiFeaturesStatus
          isEnable
          createdAt
          updatedAt
          dynamicServicePlans{
          language
          planName
          description
          }
        }
    }
}`;

export const deleteServicePlans = gql`
mutation deleteServicePlan($id: Int!){
  deleteServicePlan(id: $id){
      status
      errorMessage
  }
}`;


export const getServicePlans = gql`query getServicePlan($id: Int!) {
    getServicePlan(id: $id) {
        status
        errorMessage
        result {
          id
          userType
          planName
          duration
          currency
          description
          price
		      serviceFee
          serviceType
          mediaImage
          aiFeaturesStatus
          dynamicServicePlans{
          language
          planName
          description
          }
          isEnable
          createdAt
          updatedAt
           purchaseStatus
      PurchaseData {
        id
        userId
        price
        currency
        userType
        startDate
        endDate
        serviceFee
        duration
        servicePlanId
        servicePlanName
        serviceDescription
        serviceAIFeature
        paymentType
        servicePlanStatus
        paymentState
      }
        }
    }
}`;


export const getAllPurchaseUsers = gql`
query getAllPurchaseUsers($currentPage: Int, $searchKey: String, $userType: String, $activeStatus: String) {
  getAllPurchaseUsers(
    currentPage: $currentPage
    searchKey: $searchKey
    userType: $userType
    activeStatus: $activeStatus
  ) {
    status
    errorMessage
    count
    results {
      id
      userId
      price
      currency
      userType
      startDate
      endDate
      serviceFee
      duration
      servicePlanId
      servicePlanName
      serviceDescription
      dynamicServicePlanDetails
      serviceAIFeature
      paymentType
      servicePlanStatus
      isPlanType
      paymentState
      PurchaserData {
        firstName
        lastName
        profileId
      }
      createdAt
      updatedAt
    }
  }
}`;


export const getUserServiceHistory = gql`
query getUserServiceHistory($currentPage: Int, $userType: String, $userId: String!) {
  getUserServiceHistory(
    currentPage: $currentPage
    userType: $userType
    userId: $userId
  ) {
    status
    errorMessage
    count
    result{
    id
      userId
      price
      currency
      userType
      startDate
      endDate
      serviceFee
      duration
      servicePlanId
      servicePlanName
      serviceDescription
      dynamicServicePlanDetails
      serviceAIFeature
      paymentType
      servicePlanStatus
      paymentState
      PurchaserData {
        firstName
        lastName
        phoneNumber
        displayName
        countryCode
        profileId
      }
      purchaserEncryptEmail
       servicePlanData {
        id
        userType
        planName
        duration
        currency
        description
        price
        serviceFee
        serviceType
        mediaImage
        aiFeaturesStatus
        isEnable
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
    results {
      id
      userId
      price
      currency
      userType
      startDate
      endDate
      serviceFee
      duration
      servicePlanId
      servicePlanName
      serviceDescription
      dynamicServicePlanDetails
      serviceAIFeature
      paymentType
      servicePlanStatus
      isPlanAvailableStatus
      paymentState
      PurchaserData {
        firstName
        lastName
        phoneNumber
        displayName
        profileId
      }
      purchaserEncryptEmail
       servicePlanData {
        id
        userType
        planName
        duration
        currency
        description
        price
        serviceFee
        serviceType
        mediaImage
        aiFeaturesStatus
        isEnable
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
}`;


export const getAllUserServicePlans = gql`query getAllUserServicePlans($searchKey: String, $userType: String) {
  getAllUserServicePlans(searchKey: $searchKey, userType: $userType) {
    status
    errorMessage
    count
    results {
      id
      userType
      planName
      duration
      currency
      description
      price
      serviceFee
      serviceType
      mediaImage
      aiFeaturesStatus
      isEnable
      purchaseStatus
       dynamicServicePlans{
          language
          planName
          description
          }
      PurchaseData {
        id
        userId
        price
        currency
        userType
        startDate
        endDate
        serviceFee
        duration
        servicePlanId
        servicePlanName
        serviceDescription
        serviceAIFeature
        paymentType
        servicePlanStatus
        paymentState
      }
      createdAt
      updatedAt
    }
  }
}`;

export const getUserPurchasePlans = gql`query getUserPurchasePlans($userType:String!) {
  getUserPurchasePlans(userType:$userType) {
    status
    errorMessage
    result {
      id
      userId
      price
      currency
      userType
      startDate
      endDate
      serviceFee
      duration
      servicePlanId
      servicePlanName
      serviceDescription
      serviceAIFeature
      paymentType
      servicePlanStatus
      paymentState
    }
  }
}`;


export const getAllPurchaseServicePlans = gql`
query getAllPurchaseServicePlans($currentPage: Int, $searchKey: String, $userType: String) {
  getAllPurchaseServicePlans(currentPage: $currentPage,searchKey: $searchKey, userType: $userType) {
    status
    errorMessage
    count
    results {
      id
      userId
      price
      currency
      userType
      startDate
      endDate
      serviceFee
      duration
      servicePlanId
      servicePlanName
      serviceDescription
      serviceAIFeature
      paymentType
      servicePlanStatus
      paymentState
      dynamicServicePlanDetails
      isPlanAvailableStatus
      PurchaserData {
        firstName
        lastName
      }
      servicePlanData {
        id
        userType
        planName
        duration
        currency
        description
        price
        serviceFee
        serviceType
        mediaImage
        aiFeaturesStatus
        isEnable
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
}`;


export const updateServicePlansStatus = gql`
mutation updateServicePlansStatus($id: Int!, $isEnable: Boolean){
  updateServicePlansStatus(id: $id, isEnable: $isEnable){
      status
      errorMessage
  }
}`;


export const getPurchaseServicePlan = gql`query getPurchaseServicePlan($id: Int!) {
  getPurchaseServicePlan(id: $id) {
    status
    errorMessage
    result {
      id
      userId
      price
      currency
      userType
      startDate
      endDate
      serviceFee
      duration
      servicePlanId
      servicePlanName
      serviceDescription
      serviceAIFeature
      paymentType
      servicePlanStatus
      dynamicServicePlanDetails
      paymentState
      PurchaserData {
        firstName
        lastName
      }
      servicePlanData {
        id
        userType
        planName
        duration
        currency
        description
        price
        serviceFee
        serviceType
        mediaImage
        aiFeaturesStatus
        isEnable
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
}`;


export const getPaymentMethods = gql`query getPaymentMethods {
  getPaymentMethods {
    id
    name
    processedIn
    fees
    currency
    details
    isEnable
    paymentType
    createdAt
    updatedAt
    status
}
    }`;



export const createPurchaseServicePlan = gql`
mutation createPurchaseServicePlan($price: Float!, $currency: String!, $userType: String!, $startDate: String!, $endDate: String!, $serviceFee: Float!, $duration: String, $servicePlanId: Int!, $servicePlanName: String, $serviceDescription: String, $serviceAIFeature: Boolean, $paymentType: Int) {
  createPurchaseServicePlan(
    price: $price
    currency: $currency
    userType: $userType
    startDate: $startDate
    endDate: $endDate
    serviceFee: $serviceFee
    duration: $duration
    servicePlanId: $servicePlanId
    servicePlanName: $servicePlanName
    serviceDescription: $serviceDescription
    serviceAIFeature: $serviceAIFeature
    paymentType: $paymentType
  ) {
    status
    errorMessage
    result {
      id
      userId
      price
      currency
      userType
      startDate
      endDate
      serviceFee
      duration
      servicePlanId
      servicePlanName
      serviceDescription
      serviceAIFeature
      paymentType
      servicePlanStatus
      createdAt
      updatedAt
    }
  }
}`;


export const cancelPurchaseServicePlan = gql`
mutation cancelPurchaseServicePlan($id: Int!) {
  cancelPurchaseServicePlan(id: $id) {
    status
    errorMessage
  }
}`;


export const getPurchasePlanServiceFees = gql`
    query getPurchasePlanServiceFees($listId:Int){
      getPurchasePlanServiceFees(listId:$listId){
         result{
         guest{
          guestType
          guestValue
         }host{
           hostType
          hostValue
         }
         }
      }
    }
`;

export const getServicePlanPaymentStatus = gql`
query getServicePlanPaymentStatus($id: Int!) {
  getServicePlanPaymentStatus(id: $id) {
    result {
      id
      userId
      price
      currency
      userType
      startDate
      endDate
      serviceFee
      duration
      servicePlanId
      servicePlanName
      serviceDescription
      serviceAIFeature
      paymentType
      servicePlanStatus
      paymentState
    }
    status
    errorMessage
  }
}`;

export const getPaymentServicePlan = gql`query getPaymentServicePlan($id: Int!) {
  getPaymentServicePlan(id: $id) {
    status
    errorMessage
    result {
      id
      userId
      price
      currency
      userType
      startDate
      endDate
      serviceFee
      duration
      servicePlanId
      servicePlanName
      serviceDescription
      dynamicServicePlanDetails
      serviceAIFeature
      paymentType
      servicePlanStatus
      paymentState
      PurchaserData {
        firstName
        lastName
      }
      servicePlanData {
        id
        userType
        planName
        duration
        currency
        description
        price
        serviceFee
        dynamicServicePlans{
          language
          planName
          description
          }
        serviceType
        mediaImage
        aiFeaturesStatus
        isEnable
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
}`

export const getUserServicePlan = gql`query getUserServicePlan($servicePlanId: Int!) {
  getUserServicePlan(servicePlanId: $servicePlanId) {
    status
    errorMessage
    results {
      id
      userId
      price
      currency
      userType
      startDate
      endDate
      serviceFee
      duration
      servicePlanId
      servicePlanName
      serviceDescription
      serviceAIFeature
      paymentType
      servicePlanStatus
      paymentState
      PurchaserData {
        firstName
        lastName
      }
      createdAt
      updatedAt
    }
  }
}`;